module.exports = __webpack_public_path__ + "static/media/Denise King Headshot_1619722549811.d54713b0.png";